"use client";

import ImagePageMedia from "@/component/pdp/image-page/ImagePageMedia";
import type { ImagePageGalleryData } from "@/component/pdp/image-page/types";
import type { ReactNode } from "react";

type PdpPageGalleryRootProps = {
    galleryData: ImagePageGalleryData;
    carId?: string;
    children: ReactNode;
};

export default function PdpPageGalleryRoot({ galleryData, carId, children }: PdpPageGalleryRootProps) {
    return (
        <ImagePageMedia data={galleryData} carId={carId}>
            {children}
        </ImagePageMedia>
    );
}
